import { json, type LoaderFunctionArgs } from '@remix-run/node';
import type { ShouldRevalidateFunction } from '@remix-run/react';
import { z } from 'zod';
import { listBuildHubs } from '~/modules/build-hub/api/list-build-hubs.server';

export const BUILDHUB_PROJECTS_API = '/remix-api/build-hub/projects';

const QUERY_SCHEMA = z.object({
    limit: z.coerce.number().int().positive().max(100).nullish(),
    offset: z.coerce.number().int().nonnegative().nullish(),
});

/**
 * API endpoint to get the current user's BuildHub projects.
 * Use with the `useBuildHubProjects` hook.
 * @see {@link packages/web/app/modules/build-hub/hooks/use-build-hub-projects.ts}
 */
export const loader = async ({ context, request }: LoaderFunctionArgs) => {
    const { logger } = context;
    const url = new URL(request.url);
    const result = QUERY_SCHEMA.safeParse({
        limit: url.searchParams.get('limit'),
        offset: url.searchParams.get('offset'),
    });

    if (!result.success) {
        return json(null, { status: 400 });
    }

    try {
        const buildHubs = await listBuildHubs({
            context,
            limit: result.data.limit ?? undefined,
            offset: result.data.offset ?? undefined,
        });

        if (!buildHubs) {
            return json(null, { status: 500 });
        }

        return json({ nodes: buildHubs.nodes, pageInfo: buildHubs.pageInfo });
    } catch (error) {
        logger.error(`Error in ${BUILDHUB_PROJECTS_API}`, { error });
        return json(null, { status: 500 });
    }
};

export const shouldRevalidate: ShouldRevalidateFunction = () => {
    return false;
};
